import React from 'react';
import LocaleContext from 'components/locale/LocaleContext';

const useLocale = () => React.useContext(LocaleContext);
export default useLocale;
